import { PHASES_LIST } from "@/assets/constants/selectsLists";

export const getLabelPhase = (phaseId: number) => {
  return PHASES_LIST.find((it) => it.id === phaseId)?.name || "";
};
